// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3JJ0G","header":"PatientBlock_header__1sT54","label":"PatientBlock_label__37HwU","option":"PatientBlock_option__3GJ-l"};